import styled from "@emotion/styled";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React, { HTMLAttributes } from "react";

export const LoadingContainer: React.FC<HTMLAttributes<HTMLDivElement>> = props => (
	<LoadingContent {...props}>
		<i className="pi pi-spin pi-spinner" />
	</LoadingContent>
);

const LoadingContent = styled.div`
	height: 100px;
	${stack(undefined, "center", "center")};

	i {
		font-size: 2rem;
		color: ${colors.primary};
	}
`;
